export default {
  methods: {
    /**
     * Opens up a modal box to confirm deletion of the item.
     * @param {string} item - The string of item to be deleted.
     * @param {integer} id - The id of the item selected to be deleted.
     */
    confirmDelete (item, id) {
      this.$modal.show('confirm-delete-' + item, {id})
    }
  }
}
